import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function generateFinalCostCenterOlPayments(ids: number[]) {
  return restApiClient.url(API.centerOlPayments.generateFinalCostPayment.url).post({ ids })
}
